/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Filter_FailedInputs */



/**
* | output |
* | --- |
* | "Failed" |
*
* @param {Editor_Filter_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_filter_failed = /** @type {((inputs?: Editor_Filter_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Filter_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échoué")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehlgeschlagen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non riuscita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не пройдена")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fallido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("失敗")
	if (locale === "hi") return /** @type {LocalizedString} */ ("असफल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Reprovado")
	return /** @type {LocalizedString} */ ("Failed")
});